import permissionHttp from './permissionHttp';

const getPermissionsByUser = (context, objectId, objectType) => {
  return new Promise((resolve, reject) => {
    permissionHttp.getPermissionsByUser(context, objectId, objectType)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getPermissionsByGroup = (context, objectId, objectType) => {
  return new Promise((resolve, reject) => {
    permissionHttp.getPermissionsByGroup(context, objectId, objectType)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const addPermission = (context, permissionType, objectId, objectType, userOrGroup, userOrGroupId) => {
  return new Promise((resolve, reject) => {
    permissionHttp.addPermission(context, permissionType, objectId, objectType, userOrGroup, userOrGroupId)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const deletePermission = (context, permissionType, objectId, objectType, userOrGroup, userOrGroupId) => {
  return new Promise((resolve, reject) => {
    permissionHttp.deletePermission(context, permissionType, objectId, objectType, userOrGroup, userOrGroupId)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

export default {
  getPermissionsByUser,
  getPermissionsByGroup,
  addPermission,
  deletePermission
};



// WEBPACK FOOTER //
// ./src/api/permission/index.js